import React from 'react'
import { Edit, useTranslate } from 'react-admin'

import WithContentForm from 'components/withContentForm'

import Form from './components/form'

const Title = ({ record }) => {
	const t = useTranslate()
	return <>{record ? t('resources.Activity.edit', { name: record.name }) : t('resources.Activity.name')}</>
}

const ActivityEdit = props => (
	<Edit title={<Title />} undoable={false} {...props}>
		<WithContentForm>
			<Form />
		</WithContentForm>
	</Edit>
)

export default ActivityEdit
